<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="editUsager" :validation-schema="usagerSchema">
        <!-- Début - Boutons radio en haut -->
        <div class="row mb-10">
          <div class="col-12 d-flex justify-content-end">
            <div class="form-group radio-group-right">
              <div class="d-flex align-items-center gap-15">
                <div class="form-check">
                  <Field name="statutUsager" type="radio" value="Personne physique" id="personne-physique"
                    class="form-check-input" v-model="typeDefault" />
                  <label class="form-check-label" for="personne-physique">
                    Personne physique
                  </label>
                </div>
                <div class="form-check">
                  <Field name="statutUsager" type="radio" value="Personne morale" id="personne-morale"
                    class="form-check-input" v-model="typeDefault" />
                  <label class="form-check-label" for="personne-morale">
                    Personne morale
                  </label>
                </div>
              </div>
              <ErrorMessage name="statutUsager" class="text-danger" />
            </div>
          </div>
        </div>
        <!-- Fin - Boutons radio en haut -->
        <div class="row">
          <!-- Colonne image (uniquement pour Personne physique) -->
          <div class="col-md-3 col-sm-12 col-xm-12 col-xl-3 col-lg-3" v-if="showType">
            <div class="upload-container">
              <input type="file" name="urlImage" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                accept="image/*" hidden />
              <div class="preview-card" @click="triggerFileInput">
                <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                <div v-else class="text-center">
                  <div>
                    <i class="flaticon-camera fs-1"></i>
                  </div>
                  Cliquez pour ajouter l'image
                </div>
                <button v-if="imagePreview" class="delete-btn" @click.stop="removeImage">
                  <i class="flaticon-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-9 col-sm-12 col-xm-12 col-xl-9 col-lg-9">
            <!-- Personne Physique - Tous les champs -->
            <div class="row">
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-show="showType">
                <div class="form-group mb-5 mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nom <span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" v-model="nom" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nom" />
                  <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-show="showType">
                <div class="form-group mb-5 mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Prénom <span class="text-danger">*</span>
                  </label>
                  <Field name="prenom" type="text" v-model="prenom" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le prenom" />
                  <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
                <div class="form-group mb-5 mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse
                  </label>
                  <Field name="adresse" type="text" v-model="adresse"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'adresse" />
                  <ErrorMessage name="adresse" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
                <div class="form-group mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Email
                  </label>
                  <Field name="email" type="text" v-model="email" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'email" />
                  <ErrorMessage name="email" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone
                  </label>
                  <Field name="numtel" v-model="telephone" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                      defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2">
                    </vue-tel-input>
                  </Field>
                  <ErrorMessage name="numtel" class="text-danger" />
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-show="showType">
                <div class="form-group mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de naissance
                  </label>
                  <Field name="dateNais" type="date" v-model="dateNais"
                    class="form-control shadow-none fs-md-15 text-black" />
                  <ErrorMessage name="dateNais" class="text-danger" />
                </div>
              </div>
            </div>
          </div>

          <!-- Personne morale - Tous les champs -->
          <div class="row">
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  IFU
                </label>
                <Field name="ifu" type="text" v-model="ifu" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un ifu" />
                <ErrorMessage name="ifu" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  NPI
                </label>
                <Field name="npi" type="text" v-model="npi" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un npi" />
                <ErrorMessage name="npi" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Raison sociale <span class="text-danger">*</span>
                </label>
                <Field name="raisonSocial" type="text" v-model="raisonSocial"
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la raison sociale" />
                <ErrorMessage name="raisonSocial" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Sigle
                </label>
                <Field name="sigle" type="text" v-model="sigle" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer le sigle" />
                <ErrorMessage name="sigle" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  IFU
                </label>
                <Field name="ifu" type="text" v-model="ifu" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un ifu" />
                <ErrorMessage name="ifu" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  NPI
                </label>
                <Field name="npi" type="text" v-model="npi" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un npi" />
                <ErrorMessage name="npi" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="!showType">
              <div class="form-group mb-5 mb-sm-10 mb-md-10">
                <label class="d-block text-black fw-semibold mb-10">
                  Adresse
                </label>
                <Field name="adresse" v-model="adresse" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer l'adresse" />
                <ErrorMessage name="adresse" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="!showType">
              <div class="form-group mb-sm-10 mb-md-10">
                <label class="d-block text-black fw-semibold mb-10">
                  Email 
                </label>
                <Field name="email" type="text" v-model="email" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer l'email" />
                <ErrorMessage name="email" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Téléphone
                </label>
                <Field name="numtel" v-model="telephone" v-slot="{ field }">
                  <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                    defaultCountry="BJ" mode="international" @validate="validate"
                    class="shadow-none fs-md-15 text-black py-2">
                  </vue-tel-input>
                </Field>
                <ErrorMessage name="numtel" class="text-danger" />
                <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Date de création 
                </label>
                <Field name="dateCreation" v-model="dateCreation" type="date"
                  class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="dateCreation" class="text-danger" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xm-12 col-xl-12 col-lg-6" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Régistre de commerce
                </label>
                <Field name="rccm" type="text" v-model="rccm" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer le régistre de commerce" />
                <ErrorMessage name="rccm" class="text-danger" />
              </div>
            </div>
          </div>
        </div>

        <!-- Zone de dépôt des fichiers (commune aux deux types) -->
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="product-upload mb-10">
              <div class="dz-message needsclick">
                <DropZone name="fichiers[]" :maxFilesize="50000000" :maxFiles="Number(10000000000)" class=""
                  :uploadOnDrop="true" @addedFile="onFileAdd" @removedFile="onFileRemove" :options="dropzoneOptions"
                  @vdropzone-success="onSuccess" @vdropzone-error="onError">
                  <div class="default-image-container" v-if="!hasFiles">
                    <img :src="defaultImage" alt="Default" class="default-image" />
                    <p>Glissez et dépossez ici</p>
                  </div>
                </DropZone>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-1">
            <div class="d-flex align-items-center ">
              <button class="btn btn-success me-3" type="submit">
                Modifier
              </button>
              <router-link to="/liste-usager" class=" btn btn-danger ">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch, reactive } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success, onFileChange, getUrlApiForFiles } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { Usager } from '@/models/Usager';
import * as Yup from 'yup';
import axios from 'axios';
import { VueTelInput } from 'vue3-tel-input';
import path from 'path-browserify';
import DropZone from "dropzone-vue";

export default defineComponent({
  name: "EditUsager",
  components: {
    Form,
    Field,
    ErrorMessage,
    VueTelInput,
    DropZone
  },
  setup: () => {
    const usagerSchema = Yup.object().shape({
      statutUsager: Yup.string().required('Le statut est obligatoire'),
      // Champs personne physique
      nom: Yup.string().when('statutUsager', {
        is: "Personne physique",
        then: schema => schema.required("Le nom est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      prenom: Yup.string().when('statutUsager', {
        is: "Personne physique",
        then: schema => schema.required("Le prénom est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      dateNais: Yup.date().when('statutUsager', {
        is: "Personne physique",
        then: schema => schema.notRequired(),
        otherwise: schema => schema.notRequired()
      }),
      // Champs personne morale
      raisonSocial: Yup.string().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.required("La raison sociale est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      dateCreation: Yup.date().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.notRequired(),
        otherwise: schema => schema.notRequired()
      }),
      rccm: Yup.string().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.notRequired(),
        otherwise: schema => schema.notRequired()
      }),
      sigle: Yup.string().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.notRequired(),
        otherwise: schema => schema.notRequired()
      }),
      // Champs communs
      adresse: Yup.string().notRequired(),
      email: Yup.string().email("Veuillez entrer un mail valide").notRequired(),
      numtel: Yup.string().notRequired(),
      ifu: Yup.string()
        .matches(/^\d{13}$/, "IFU doit contenir exactement 13 chiffres.")
        .notRequired(),
      npi: Yup.string()
        .matches(/^\d{10}$/, "NPI doit contenir exactement 10 chiffres.")
        .notRequired(),
    });
    const typeDefault = ref("Personne physique")
    const showType = ref(true);
    const nom = ref("");
    const prenom = ref("");
    const sexe = ref("");
    const typeUsager = ref("");
    const email = ref("");
    const adresse = ref("");
    const npi = ref("");
    const ifu = ref("");
    const rccm = ref("");
    const sigle = ref("");
    const dateNais = ref("");
    const raisonSocial = ref("");
    const dateCreation = ref("")
    const usagerForm = ref<Usager>();
    const validPhone = ref(false);
    const telephone = ref("");
    const router = useRouter();
    const identifiant = ref("");
    const route = useRoute();
    const defaultImage = path.join('/public', 'welcome2.png');
    const hasFiles = ref(false);
    const toutFichier = ref<Array<File>>([])
    const numtel = ref("");
    const numberPhone = ref("");
    const selectedFile = ref<{ file: File | null, previewUrl: string | null }>({
      file: null,
      previewUrl: null
    });
    const handleNumtelInput = (event) => {
      if (event.target.value) {
        let value = event.target.value.replace(/\D/g, "");
        if (value.length <= 8) {
          numtel.value = value;
        }
      }

    };
    const photoFileNameChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        selectedFile.value = {
          file: file,
          previewUrl: URL.createObjectURL(file)
        };
      }
    };
    const fileInput = ref();
    const imagePreview = ref<string | null>(null);
    const imageFile = ref(null);
    const triggerFileInput = () => {
      fileInput.value.click();
    };
    const getUsager = async (id: number) => {
      ApiService.get("/usagers/" + id.toString())
        .then(async ({ data }) => {
          console.log("data", data);
          if (data.data && data.data.medias) {
            const photoMedia = data.data.medias.find((media) => media.typeMedia === "Photo");
            console.log('photomedia', photoMedia);
            if (photoMedia) {
              imagePreview.value = await getUrlApiForFiles('Marchands', photoMedia.nomMedia);
            }
          }
          const lus = data.data;
          nom.value = lus.nom;
          prenom.value = lus.prenom;
          sexe.value = lus.sexe;
          typeDefault.value = lus.typeUsager == null ? 'Personne physique' : 'Personne morale';
          adresse.value = lus.adresse;
          npi.value = lus.npi;
          email.value = lus.email;
          ifu.value = lus.ifu;
          dateNais.value = lus.dateNais;
          dateCreation.value = lus.dateCreation;
          telephone.value = lus.numtel ? lus.numtel : "";
          raisonSocial.value = lus.raisonSocial;
          sigle.value =lus.sigle;
          rccm.value = lus.rccm;



          console.log('Image len ===> ', imagePreview.value);
          // for (const key in data.data) {
          //   usagerForm.value?.setFieldValue(
          //     key,
          //     typeof data.data[key] === "object" && data.data[key] !== null
          //       ? data.data[key].id
          //       : data.data[key]
          //   );
          // }


        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }
    /*const editUsager = async (values, { resetForm }) => {
      try {
        const response = await ApiService.put(`/usagerxs/${values.id}`, values);
        
        if (response.status === 200) {
          success(response.data.message);
          resetForm();
          router.push({ name: "ListeUsagerPage" });
        }
      } catch (error) {
       // error(error.response?.data?.message || "Une erreur est survenue.");
      }
    };*/
    const validate = (phoneObject: any) => {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid) {
        telephone.value = phoneObject.number;
        numberPhone.value = phoneObject.nationalNumber;
      } else {
        telephone.value = "";
        numberPhone.value = "";
      }
    };
    const editUsager = async (values, { resetForm }) => {
      delete values.createdAt;
      delete values.deletedAt;
      delete values.medias;
      delete values.updatedAt;
      delete values.addRef;
      delete values.id;
      console.log("Données", values); // Vérifier les données avant envoi
      values.id = identifiant.value;
      values.typeUsager = typeDefault.value;
      values.numtel = telephone.value;
      values['autreFichier[]'] = [];
      values["urlImage"] = [];


      if (toutFichier.value.length > 0) {
        values['autreFichier[]'] = toutFichier.value;
      }
      if (imageFile.value) {
        values["urlImage"] = imageFile.value;
      }
      const url = `usagerxs/${identifiant.value}`;
      console.log("url", url);
      await axios.put(url, values, {
        headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
      })
        .then(({ data }) => {
          console.log('Réponse du backend:', data);
          if (data.code == 200) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeUsagerPage" });
          }
        })
        .catch(({ response }) => {
          console.error("Erreur backend:", response.data);
          error(response.data.message);
        });
    };
    const onFileAdd = (file: any) => {
      console.log("Fichier ajouté ===> ", file);
      toutFichier.value.push(file["file"]);
      hasFiles.value = true;
    };
    const onFileRemove = (file: File) => {
      console.log("Fichier retiré ==> ", file);
      const index = toutFichier.value.findIndex(fil => ((fil.name === file["file"].name) && (fil.size === file["file"].size) && (fil.type === file["file"].type)));
      if (index !== -1) {
        toutFichier.value.splice(index, 1);
      } else {
        console.log(`Le fichier ${file["file"].name} n'a pas été trouvé dans le tableau.`);
      }
      hasFiles.value = toutFichier.value.length > 0;
    };
    const images = reactive([
      {
        file: null as File | null,
        previewUrl: null as string | null,
      },
    ]);

    const dropzoneOptions = {
      url: 'your-upload-url', // URL de téléchargement des fichiers
      thumbnailWidth: 150,
      maxFilesize: 50, // Taille maximale du fichier en Mo
      maxFiles: 10, // Nombre maximal de fichiers
      headers: { "My-Awesome-Header": "header value" },
      acceptedFiles: 'image/*',
    };
    const onSuccess = (file) => {
      console.log('Upload réussi:', file);
    };
    const onError = (file, message) => {
      console.error('Erreur de téléchargement:', message);
    };
    const onFilePrinChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target) {
            imagePreview.value = e.target.result as string;
          }
        };
        reader.readAsDataURL(file);
      }
    };
    const removeImage = () => {
      imagePreview.value = null;
      imageFile.value = null;
    };
    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      if (file) {
        images[index].previewUrl = URL.createObjectURL(file);
        images[index].file = file;
      }
    };
    onMounted(async () => {
      if (route.params.id) {
        identifiant.value = route.params.id as string;
        await getUsager(parseInt(route.params.id as string));
      }
    });
    watch(telephone,(newValue) => {
      if (newValue.length > 0) {
        numtel.value = newValue;
        console.log("Numéro de téléphone:", numtel.value);
      }
    });
    watch(typeDefault, (newValue) => {
      if (newValue === "Personne physique") {
        typeDefault.value = "Personne physique";
        showType.value = true;
      } else {
        typeDefault.value = "Personne morale";
        showType.value = false;
      }
    });
    return {
      usagerSchema, editUsager, usagerForm,
      sexe,
      showType,
      typeDefault,
      onFilePrinChange,
      dateCreation,
      hasFiles,
      onFileRemove,
      onFileAdd,
      toutFichier,
      triggerFileInput,
      onSuccess,
      onError,
      dropzoneOptions,
      onFileChange,
      validate,
      defaultImage,
      removeImage,
      photoFileNameChange,
      fileInput,
      handleNumtelInput,
      imagePreview,
      imageFile,
      selectedFile,
      numtel,
      getUrlApiForFiles,
      telephone,
      email,
      npi,
      ifu,
      adresse,
      raisonSocial,
      rccm,
      nom,
      dateNais,
      sigle,
      validPhone,
      prenom,

    };
  },
});
</script>

<style scoped>
.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 240px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  padding: 5px 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.delete-btn:hover {
  background: darkred;
}
</style>